import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { useMember } from 'shared-ui/components/pages/PageWrapper'
import { resolveUrlVariables } from 'shared-ui/utils/resolveUrlVariables'

export default function Link(props) {
  const { to = '', ...rest } = props
  const member = useMember()

  if (!to || typeof to !== 'string') return <a {...rest} />

  if (/^https?:\/\//.test(to)) return <a href={resolveUrlVariables(to, member)} {...rest} />

  return <RouterLink {...props} />
}
